/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppSetting } from '../../models/app-setting';

export interface AppSettingsControllerFindByKey$Params {
  key: string;
}

export function appSettingsControllerFindByKey(http: HttpClient, rootUrl: string, params: AppSettingsControllerFindByKey$Params, context?: HttpContext): Observable<StrictHttpResponse<AppSetting>> {
  const rb = new RequestBuilder(rootUrl, appSettingsControllerFindByKey.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppSetting>;
    })
  );
}

appSettingsControllerFindByKey.PATH = '/settings/{key}';
